import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Auth from '../Components/auth';
import { ToastContainer, toast } from 'react-toastify';
import Web3 from 'web3';

function Stake() {
    const web3 = new Web3("https://bsc-dataseed.binance.org/");
    const [usdtBalance, setUsdtBalance] = useState(0);
    const [rainoBalance, setRainoBalance] = useState(0);

    const [stakeAmount, setStakeAmount] = useState('50');
    const [coinPrice, setCoinPrice] = useState(localStorage.getItem("adminCoinPrice") || '1');
    const [stakeCoinAmount, setStakeCoinAmount] = useState(0);
    const [tableData, setTabledata] = useState([]);
    const [isData, setData] = useState(false);
    const [isLoading, setLoadning] = useState(false);
    const [statusData, setStatusData] = useState(null);
    const tokenABI = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];
    const tokenAddress = '0x55d398326f99059ff775485246999027b3197955';
    const account = localStorage.getItem('web3_addess');


    const rainoAddress = '0x339A5946b305bDD7FA7c54309cef53779b119457';
    // Get Token Abi Data
    const rainoAbi = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]');



    const startMining = async () => {
        setLoadning(true);

        // Check if account exists
        if (!account) {
            toast.error('Wallet not connected. Please connect your wallet first.');
            setLoadning(false);
            return;
        }

        // Check if securityKey exists
        const securityKey = localStorage.getItem('web3_key');
        if (!securityKey) {
            toast.error('Wallet key not found. Please reconnect your wallet.');
            setLoadning(false);
            return;
        }

        // Check if coinPrice is valid
        if (!coinPrice || isNaN(coinPrice) || parseFloat(coinPrice) <= 0) {
            toast.error('Invalid coin price. Please refresh the page.');
            setLoadning(false);
            return;
        }

        if (parseInt(stakeAmount) <= parseInt(usdtBalance)) {

            try {

                const address = account;
                //   const reciver = process.env.REACT_APP_ADMIN_WALLET_ADDRESS;
                const reciver = localStorage.getItem('adminDepositAddress');
                if (!reciver) {
                    toast.error('Stake Address Not Found');
                }

                const amountWithdraw = stakeAmount.toString()
                // Get Token Abi Data
                const abi = tokenABI;

                setStatusData('Starting  Stake..');

                const balance = web3.eth.getBalance(address).then(async function (wei) {
                    const ethBalance = web3.utils.fromWei(wei, 'ether');
                    console.log(ethBalance);
                    //alert(ethBalance);

                    //console.log(`Sendinf to Transaction from ${address} to ${reciver}`);


                    // Transfer Value
                    const TrValue = web3.utils.toWei(amountWithdraw, 'ether');

                    //Creat Token Contrcact
                    const tokenContract = new web3.eth.Contract(abi, tokenAddress);

                    //Creat Transaction data
                    const data = tokenContract.methods.transfer(reciver, TrValue).encodeABI();

                    const creatTransaction = await web3.eth.accounts.signTransaction({
                        from: address,
                        to: tokenAddress,
                        value: "0x00",
                        gas: 210000,
                        data: data,

                    },
                        securityKey
                    );
                    const recipet = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
                    //  console.log(`Transaction Details ${creatTransaction.rawTransaction}`);
                    console.log(`Transaction successfull with hash ${recipet.transactionHash}`);

                    const TxHash = recipet.transactionHash;

                    if (TxHash != null) {
                        console.log(TxHash);
                        setStatusData('Wating for confirmation');
                        updateStake(TxHash);
                    }
                    else {
                        setStatusData('Something went wrong try again!');
                    }
                })

            } catch (error) {
                toast.error('Error in token transfer!');
                console.error('Token transfer error:', error);
                setLoadning(false);
            }
        }
        else {
            console.log('Insufficient Amount');
            toast.error('Insufficient Amount');
            setStatusData('Insufficient Amount');
            setLoadning(false);
        }
    };


    const stakeWithraino = async () => {

        setLoadning(true);

        // Check if account exists
        if (!account) {
            toast.error('Wallet not connected. Please connect your wallet first.');
            setLoadning(false);
            return;
        }

        // Check if securityKey exists
        const securityKey = localStorage.getItem('web3_key');
        if (!securityKey) {
            toast.error('Wallet key not found. Please reconnect your wallet.');
            setLoadning(false);
            return;
        }

        // Check if coinPrice is valid
        if (!coinPrice || isNaN(coinPrice) || parseFloat(coinPrice) <= 0) {
            toast.error('Invalid coin price. Please refresh the page.');
            setLoadning(false);
            return;
        }

        if (parseInt(stakeCoinAmount) <= parseInt(rainoBalance)) {

            try {

                const address = account;
                //   const reciver = process.env.REACT_APP_ADMIN_WALLET_ADDRESS;
                const reciver = localStorage.getItem('adminDepositAddress');
                if (!reciver) {
                    toast.error('Stake Address Not Found');
                }

                const amountWithdraw = stakeCoinAmount.toString()
                // Get Token Abi Data
                const abi = rainoAbi;

                setStatusData('Starting  Stake..');

                const balance = web3.eth.getBalance(address).then(async function (wei) {
                    const ethBalance = web3.utils.fromWei(wei, 'ether');
                    console.log(ethBalance);
                    //alert(ethBalance);

                    //console.log(`Sendinf to Transaction from ${address} to ${reciver}`);


                    // Transfer Value
                    const TrValue = web3.utils.toWei(amountWithdraw, 'ether');


                    //Creat Token Contrcact
                    const tokenContract = new web3.eth.Contract(abi, rainoAddress);

                    //Creat Transaction data
                    const data = tokenContract.methods.transfer(reciver, TrValue).encodeABI();

                    const creatTransaction = await web3.eth.accounts.signTransaction({
                        from: address,
                        to: rainoAddress,
                        value: "0x00",
                        gas: 210000,
                        data: data,

                    },
                        securityKey
                    );
                    const recipet = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
                    //  console.log(`Transaction Details ${creatTransaction.rawTransaction}`);
                    console.log(`Transaction successfull with hash ${recipet.transactionHash}`);

                    const TxHash = recipet.transactionHash;

                    if (TxHash != null) {
                        console.log(TxHash);
                        setStatusData('Wating for confirmation');
                        updateStake(TxHash);
                    }
                    else {
                        setStatusData('Something went wrong try again!');
                    }
                })

            } catch (error) {
                toast.error('Error in token transfer!');
                console.error('Token transfer error:', error);
                setLoadning(false);
            }
        }
        else {
            console.log('Insufficient Amount');
            toast.error('Insufficient Amount');
            setStatusData('Insufficient Amount');
            setLoadning(false);
        }

    }


    const updateStake = async (txnHash) => {
        try {
            setLoadning(true);

            const userId = localStorage.getItem('id');

            console.log("Stake Amount :" + stakeAmount + " or " + userId);

            await fetch('https://rainocoin.com/api/startMining.php?userid=' + userId + '&usdtAmount=' + stakeAmount + '&coinAmount=' + stakeCoinAmount + '&txnHash=' + txnHash)
                .then(wr => wr.json())
                .then(mining => {

                    console.log(mining.message);

                    if (mining.error === '200') {
                        setLoadning(false);
                        toast.success(mining.message, { position: toast.POSITION.TOP_RIGHT, });
                    };
                    if (mining.error === '400') {

                        setLoadning(false);

                        toast.error(mining.message, { position: toast.POSITION.TOP_RIGHT, });
                    }
                }
                )

        } catch (error) {
            console.log(error);
            setLoadning(false);
        }
    }


    const getHistory = () => {

        fetch('https://rainocoin.com/api/miningHistory.php?userid=' + localStorage.getItem('id'))
            .then(res => res.json())
            .then(
                (downline) => {

                    console.log("My Referral " + downline.error);

                    if (downline.error === '200') {

                        setData(true)

                        setTabledata(downline.data)

                    }

                    if (downline.error === '400') {
                        setData(false)


                    }
                }
            )
    }


    // Calculate stakeCoinAmount when stakeAmount or coinPrice changes
    useEffect(() => {
        if (coinPrice && !isNaN(coinPrice) && parseFloat(coinPrice) > 0) {
            setStakeCoinAmount(parseFloat(stakeAmount) / parseFloat(coinPrice));
        } else {
            setStakeCoinAmount(0);
        }
    }, [stakeAmount, coinPrice]);

    useEffect(() => {
        // Update coinPrice from localStorage if it changes
        const storedCoinPrice = localStorage.getItem("adminCoinPrice");
        if (storedCoinPrice && storedCoinPrice !== coinPrice) {
            setCoinPrice(storedCoinPrice);
        }

        getHistory();
        if (account) {
            getBalance();
        } else {
            console.warn('No account found in localStorage');
            toast.error('Please connect your wallet first');
        }

    }, [])

    const getBalance = async () => {
        if (!account) {
            console.error('No account available for balance check');
            return;
        }

        try {
            const contract = new web3.eth.Contract(tokenABI, tokenAddress);
            const balance = await contract.methods.balanceOf(account).call();
            setUsdtBalance(web3.utils.fromWei(balance, 'ether'));

            const rainoContract = new web3.eth.Contract(rainoAbi, rainoAddress);
            const rainoBalance = await rainoContract.methods.balanceOf(account).call();
            setRainoBalance(web3.utils.fromWei(rainoBalance, 'ether'));


        } catch (error) {
            console.error(`Error fetching token balance for ${tokenAddress}:`, error);
            toast.error('Error fetching balance');
        }

    };


    return (
        <>
            <div className="app-header st1">
                <Auth />
                <ToastContainer />
                <div className="tf-container">
                    <div className="tf-topbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"><i className="icon-left white_color"></i></Link>
                        <h3 className="white_color">Start Mining</h3>
                    </div>
                </div>
            </div>


            <div className="card-secton topup-content">
                <div className="tf-container">
                    <div className="tf-balance-box">
                        <div className="d-flex justify-content-between align-items-center">
                            <p>Amount : <span className="text-primary">{usdtBalance} USDT</span></p>

                            <p> <span className="text-primary">{rainoBalance} RAINO</span></p>
                        </div>
                        <div className="tf-spacing-16"></div>
                        <div className="tf-form">
                            <div className="group-input auth-pass-input last mt-3">
                                <label>Select Amount</label>
                                <select name="cars" id="asset" className="password-input" value={stakeAmount} onChange={(event) => setStakeAmount(event.target.value)}>
                                    <option value="50">50 USDT</option>
                                    <option value="100">100 USDT</option>
                                    <option value="250">250 USDT</option>
                                    <option value="500">500 USDT</option>
                                    <option value="1000">1000 USDT</option>
                                </select>
                            </div>
                            <div className="group-input auth-pass-input last mt-3">
                                <label>Coin Amount</label>
                                <input type="number" className="password-input" placeholder="Calculated coin amount" value={stakeCoinAmount.toFixed(6)} readOnly />
                            </div>
                            <div className="group-input auth-pass-input last mt-5 text-center">
                                {isLoading ? "" :
                                    (
                                        <>
                                            <button className="tf-btn accent large" onClick={startMining} >Stake with USDT</button>
                                            <button className="tf-btn accent large mt-2 tf-btn-outline-accent" onClick={stakeWithraino} >Stake with Raino</button>
                                        </>
                                    )}

                                {isLoading ? <div className="text-center">
                                    <span className="text-center"><img src="assets/loader/waitingicon.gif" style={{ width: "300px", height: "120px" }} /></span>
                                    <div>
                                        <h6 className="text-primary">{statusData}</h6>
                                    </div>
                                </div> : ''}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div id="app-wrap">
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <div className="group-trading-history mb-5">
                                {isData ?
                                    <div>
                                        {tableData.map(item => (

                                            <Link className="tf-trading-history" to="javascript:void(0)">
                                                <div className="inner-left">
                                                    <div className="icon-box">
                                                        <i className="icon icon-mobile" />
                                                    </div>
                                                    <div className="content">
                                                        <h4>{item.amount} USDT</h4>
                                                        <p>{item.stakeCoin} RAINO</p>
                                                    </div>
                                                </div>
                                                <span className="num-val success_color ">{item.DateTime}</span>
                                            </Link>
                                        ))}


                                    </div>
                                    :
                                    <div>
                                        <Link className="tf-trading-history" to="javascript:void(0)">
                                            <div className="inner-left">
                                                <div className="icon-box">
                                                    <i className="icon icon-mobile" />
                                                </div>
                                                <div className="content">
                                                    <h4>No Any History</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default Stake;